import { Box, Button } from '@ouster/webviz-react-components';

import { MdArrowBack } from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';

import AdminOrgSummary from '../../components/adminDashboard/AdminOrgSummary';
import AdminOrgUsers from '../../components/adminDashboard/AdminOrgUsers';

export default function AdminDashboardOrgDetail() {
  const { orgId } = useParams();

  if (orgId === undefined) return null;

  return (
    <Box
      display="grid"
      rowGap="2rem"
      gridTemplateRows="auto auto 1fr"
      height="100%"
      overflow="hidden"
    >
      <Box mb={2}>
        <Link to="/admin_dashboard/org">
          <Button variant="link" subtle>
            <MdArrowBack size={20} style={{ marginRight: '0.5rem' }} />
            Back to the Organization List
          </Button>
        </Link>
      </Box>
      <AdminOrgSummary orgId={parseInt(orgId, 10)} />
      <AdminOrgUsers orgId={parseInt(orgId, 10)} />
    </Box>
  );
}
